import React from 'react';
import HomeLayout from './HomeLayout';
import { HOMEPAGE_CONTACT } from '../common/constants';

const ContactUsLayout = props => {
    return <HomeLayout {...props} subPage={HOMEPAGE_CONTACT} />;
};

export default ContactUsLayout;
